/** "A new version is ready": shown when a built update is waiting; nothing reloads until tapped. */
import { Button } from '@qrkey/ui';
import { useUpdateState } from './update.js';

export function UpdatePrompt() {
  const { state, apply } = useUpdateState();
  if (state === 'idle') return null;
  return (
    <div className="update-prompt" role="status" aria-live="polite">
      <span>A new version of QRkey is ready.</span>
      <Button onClick={apply} disabled={state === 'applying'}>
        {state === 'applying' ? 'Updating…' : 'Update now'}
      </Button>
    </div>
  );
}
